import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import UserMixin from '@/_mixins/user'
import Dialog from '@/components/Dialog/Dialog.vue'

@Component({
    components: { Dialog },
    mixins: [UserMixin],
})
export default class SecondaryEmail extends Mixins<MixinInterface>(UserMixin) {
    @Prop({ required: true }) emailId!: string
    @Prop() disabledPrimary!: boolean
    @Prop() disabledDelete!: boolean

    email: any = null

    created() {
        this.email = JSON.parse(JSON.stringify(this.$store.getters.secondaryEmail(this.emailId)))
    }

    // DIALOG
    loading = false
    primaryDialog = false
    deleteDialog = false

    get secondaryEmailUrl() {
        if (!this.email?.id) return ''
        return `${this.url_user}/secondaryEmails/${this.email.id}`
    }

    async makePrimary() {
        this.loading = true
        await this.postGeneralRequest(this.secondaryEmailUrl + '/makePrimary').catch(() => {
            this.loading = false
        })
        this.loading = false
        this.close()
        this.$emit('changed')
    }

    async deleteSecondaryEmail() {
        this.loading = true
        await this.deleteEmail(this.emailId).catch(() => {
            this.loading = true
        })
        this.loading = false
        this.close()
        this.$emit('changed')
    }

    close() {
        this.primaryDialog = false
        this.deleteDialog = false
    }
}
